import React, { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { Loader } from '@corecomponents/ui'
import { useAmbassadorContext } from '@context/context'
import {
  CookieDomain,
  CookieKeys,
  CookieService,
  deleteAllCookies,
} from '@api/hooks/ambassdor/cookie-service'

type PrivateRoutesProps = {}

const PrivateRoutes: React.FC<PrivateRoutesProps> = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { dispatch } = useAmbassadorContext()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const token = localStorage.getItem('TOKEN') as string

      const currentStatus =
        localStorage && (localStorage.getItem('currentStatus') as string)

      if (token && token?.length > 0) {
        setIsAuthenticated(true)
        if (currentStatus) {
          dispatch({ type: 'MY_PROFILE_DATA', value: currentStatus })
        }
      } else {
        localStorage.clear()
        sessionStorage.clear()
        CookieService.deleteCookie(
          CookieKeys.TOKEN_CONTEXT,
          CookieDomain.PHYSICSWALLAH_LIVE
        )
        deleteAllCookies()
        setIsAuthenticated(false)
      }
      setIsLoading(false)
    }
  }, [])
  console.log("isAuthenticated", isAuthenticated)
  if (isLoading) {
    return <Loader />
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />
}

export default PrivateRoutes
